import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDrag } from 'react-dnd';
import { generateObjectId } from '@builttocreate/engine-utils';

import Icon from '../../misc/Icon';

import ThemeIcons from '../../../theme/Icons';
import ThemeContext from '../../../theme/ThemeContext';

const StyledItem = styled.div` 
  display: flex; 
  flex-direction: row;
  align-items: center;
  height: 52px;
  background-color: ${(props) => props.theme.backgroundColor};
  border: 0.5px groove ${(props) => props.theme.borderColor};
  border-left: 0px;
  border-right: 0px;
  border-bottom: 0px;
  padding: ${(props) => (props.styles && props.styles.padding ? `${props.styles.padding}` : '0px 15px 0px 15px')};
  transition: all 0.15s ease-in-out;
  :hover {
    ${(props) => `border: 1px solid ${props.theme.primaryColor};`}
    cursor: grab;
    svg.fa-grip-vertical {
      color: ${(props) => props.theme.primaryColor};
    }
  };
`;

const StyledTitleWrapper = styled.div` 
  flex: 1;
`;

const StyledTitle = styled.div` 
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: -0.01em;
  text-align: left;
  color: ${(props) => props.theme.fontColorPrimary};
`;

const StyledDesc = styled.div` 
  font-size: 11px;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: -0.01em;
  text-align: left;
  color: ${(props) => props.theme.fontColorSecondary};
  margin-top: 2px;
`;

const FieldListItemIconWrapper = styled.span`
  border-radius: 5px;
  border-radius: ${(props) => props.theme.borderRadius}px;
  background-color: ${(props) => props.theme.secondaryColor};
  margin-left: 15px;
  margin-right: 15px;
  width: 26px;
  height: 26px;
  text-align:center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FieldListItem = ({ type, icon, title, description, field, extraStyles }) => {

  const theme = useContext(ThemeContext);

  const item = {
    type,
    field: generateObjectId(),
    ...field
  };

  if (item.options && item.options[0] && !item.targetValue) {
    item.targetValue = item.options[0]?._id;
  }

  const [collectedProps, drag] = useDrag({ type, item });

  return (
    <StyledItem
      id={`field-list-item-${type}`}
      ref={drag}
      theme={theme}
      {...collectedProps}
      data-testid={`field-list-item-${type}`}
      styles={extraStyles}
    >
      <Icon
        icon={ThemeIcons.misc.drag}
        size="sm"
        color={theme.borderColor}
        hoverColor={theme.borderColor.primaryColor}
        hoverCursor="grab"
      />
      <FieldListItemIconWrapper theme={theme}>
        <Icon
          icon={icon}
          size="sm"
          color={theme.fontColorPrimary}
        />
      </FieldListItemIconWrapper>

      <StyledTitleWrapper>
        <StyledTitle theme={theme}>{title}</StyledTitle>
        {!description ? null : <StyledDesc theme={theme} data-testid="field-list-item-description">{description}</StyledDesc>}
      </StyledTitleWrapper>
    </StyledItem>
  );

};

FieldListItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  type: PropTypes.string.isRequired,
  field: PropTypes.object.isRequired,
};

export default FieldListItem;
